import { useState } from "react";
import { useIntl } from "react-intl";
import { SegmentedControl } from "@/components/design/SegmentedControl";
import { AccessInspectionPersonPicker, type InspectionPerson } from "./AccessInspectionPersonPicker";
import { AccessInspectionResult } from "./AccessInspectionResult";
import { AccessPersonCompare } from "./AccessPersonCompare";
import { AccessGroupInspection } from "./AccessGroupInspection";

export function AccessInspectionPanel() {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id });
  const [mode, setMode] = useState("person");
  const [person, setPerson] = useState<InspectionPerson | null>(null);
  const [first, setFirst] = useState<InspectionPerson | null>(null);
  const [second, setSecond] = useState<InspectionPerson | null>(null);
  return <section id="access-inspection" className="@container box min-w-0 space-y-6 bg-surface p-6" aria-labelledby="access-inspection-title">
    <div><h2 id="access-inspection-title" className="text-smycles-title font-medium">{t("admin.inspection.title")}</h2>
      <p className="mt-2 text-smycles-body text-ink">{t("admin.inspection.intro")}</p></div>
    <SegmentedControl id="inspection-mode" value={mode} onChange={setMode} aria-label={t("admin.inspection.target")}
      options={[{ value: "person", label: t("admin.inspection.person") }, { value: "group", label: t("admin.inspection.group") },
        { value: "compare", label: t("admin.inspection.compare") }]} />
    {mode === "person" && <>
      <AccessInspectionPersonPicker id="inspection-person" person={person} onSelect={setPerson} label={t("admin.inspection.search")} />
      {person ? <AccessInspectionResult key={person.id} personId={person.id} />
        : <p className="text-smycles-meta text-ink-muted">{t("admin.inspection.searchHint")}</p>}
    </>}
    {mode === "group" && <AccessGroupInspection />}
    {mode === "compare" && <>
      <div className="grid gap-6 @min-[40rem]:grid-cols-2">
        <AccessInspectionPersonPicker id="inspection-first" person={first} onSelect={setFirst} excludedId={second?.id} label={t("admin.inspection.first")} />
        <AccessInspectionPersonPicker id="inspection-second" person={second} onSelect={setSecond} excludedId={first?.id} label={t("admin.inspection.second")} />
      </div>
      {first && second ? <AccessPersonCompare key={`${first.id}:${second.id}`} first={first} second={second} />
        : <p className="text-smycles-body text-ink-muted">{t("admin.inspection.pickBoth")}</p>}
    </>}
  </section>;
}
